import { gql } from '@/__generated__';

const ALERT_STATE_FRAGMENT = gql(`#graphql
  fragment GetAlertStateFragment on AlertConfigurationByState {
    comparisonType
    thresholdMin
    thresholdMax
    thresholdValue
    notificationDelaySec
    metricUnit
  }
`);


export const GET_ALERT_CONFIGURATION = gql(`#graphql
  query UpdateAlertsModal_GetAlertConfiguration($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      metrics {
        id
        availableFields
      }
      alerts {
        id
        activeConfigurations {
          id
          deviceId
          metric
          ok {
            id
            ...GetAlertStateFragment
          }
          info {
            id
            ...GetAlertStateFragment
          }
          warning {
            id
            ...GetAlertStateFragment
          }
          critical {
            id
            ...GetAlertStateFragment
          }
        }
      }
    }
  }
`);
